import { BOA_KEY, shUrls, VERSION } from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getAllUsersSH = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${shUrls.GET_ALL_USERS_SH}`);
};
export const addUsersSH = async (data) => {
  return await postData(BOA_KEY + VERSION + shUrls.SAVE_USERS_SH, data);
};

export const removeUserSH = async (key) => {
  return await deleteData(BOA_KEY + VERSION + shUrls.DELETE_SH, key);
};

export const updateUserSH = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${shUrls.UPDATE_USER_SH}`,
    data
  );
};
